<template>
    <div class="wrapper presentation-page">
      <div>
        <b-sidebar id="sidebar-right" title="Articles" right shadow>
          <div class="px-3 py-2">
            <div class="row" style="text-decoration: none;">
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://globalnews.ca/news/8417802/montreal-area-teacher-rap-video-to-be-reinstated/">
                          <img class="img rounded news-card-img" src="img/chad/press/global-news-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://www.tvanouvelles.ca/2021/12/01/le-prof-rappeur-de-chateauguay-pourra-reprendre-ses-cours">
                          <img class="img rounded news-card-img" src="img/chad/press/tva-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://www.journaldemontreal.com/2021/11/30/suspension-annulee-pour-le-prof-rappeur-de-chateauguay">
                          <img class="img rounded news-card-img" src="img/chad/press/journal-montreal-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://www.lecourrierdusud.ca/un-enseignant-suspendu-pour-son-videoclip-de-hip-hop/">
                          <img class="img rounded news-card-img" src="img/chad/press/courrier-du-sud-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://www.cybersoleil.com/teacher-suspended-by-new-frontiers-will-return-to-work/?fbclid=IwAR0K022piFS9ftGgb0ddesiX-KszKhCnfqIJ4w6iscJmbQ6aqhmCn_7Ptuc">
                          <img class="img rounded news-card-img" src="img/chad/press/soleil-chateaugay-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="#pablo">
                          <img class="img" src="img/chad/press/global-news-logo.png"/>
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://www.cybersoleil.com/l-enseignant-suspendu-par-New-Frontiers-retournera-au-travail/">
                          <img class="img rounded news-card-img" src="img/chad/press/soleil-chateaugay-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://montreal.ctvnews.ca/montreal-area-teacher-suspended-over-showing-his-hip-hop-music-video-to-students-allowed-to-teach-again-1.5693352">
                          <img class="img rounded news-card-img" src="img/chad/press/ctv-news-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://www.qub.ca/article/un-prof-suspendu-pour-un-videoclip-1061298175">
                          <img class="img rounded news-card-img" src="img/chad/press/qub-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://selonwalter.com/prof-suspendu-pour-son-videoclip-stereotypes-dun-homme-noir-mal-compris/?fbclid=IwAR3VfD03fm_9Xt1Zcoemw766oGbHdGrXkDcNFFxjEprzEEvA8DihyU2Z2Bw">
                          <img class="img rounded news-card-img" src="img/chad/press/walter-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://cfcnews.com/326271/">
                          <img class="img rounded news-card-img" src="img/chad/press/cfc-logo.png">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-xl-6 col-lg-6 ">
                <card type="profile">
                  <div slot="raw-content" class="row">
                    <div class="col-md-12">
                      <div class="card-image">
                        <a href="https://montreal.citynews.ca/2021/12/01/quebec-teacher-suspended-bathing-suit/">
                          <img class="img rounded news-card-img" src="img/chad/press/city-news-logo.jpg">
                        </a>
                      </div>
                    </div>
                  </div>
                </card>
              </div>
            </div>
          </div>
        </b-sidebar>
      </div>
        <div class="page-header clear-filter">
            <div class="page-header-image rellax-header"
                 style="background-image: url('img/chad/edits-11.jpg');
                 z-index: 1;
                 background-position: unset">
            </div>
            <div class="content-center-chad">
              <div class="container text-left">
                <div class="content-center-chad">
                  <div class="row">
                    <div class="col-md-6 ml-auto mr-auto text-left">
                      <h1 class="title">Chad Ashe</h1>
                      <h4 class="description ">
                        {{ $t('welcomeMsg') }}
                        <span class="controversy-link" v-b-toggle.sidebar-right>
                          {{ $t('controversy') }}
                        </span>
                        <router-link :to="{ path: `/about` }">
                          <br><b class="text-success"> {{ $t('readMore') }}</b>
                        </router-link>

<!--                        <div>-->
<!--                          <b-button v-b-toggle.sidebar-right>Toggle Sidebar</b-button>-->
<!--                        </div>-->

                      </h4>
                    </div>
                    <div class="col-md-6">
                      <div class="iframe-container">
                        <!--                        <iframe width="560"-->
                        <!--                                height="315"-->
                        <!--                                src="https://www.youtube.com/embed/Gbyoyqhxi60"-->
                        <!--                                title="YouTube video player"-->
                        <!--                                frameborder="0"-->
                        <!--                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"-->
                        <!--                                allowfullscreen>-->
                        <!--                        </iframe>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div id="videos" class="section">
          <div class="blogs-2" id="blogs-2">
            <div class="container">
              <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                  <h2 class="title text-center">{{ $t('videos') }}</h2>
                  <br />
                  <div class="row justify-content-center">
                    <div class="col-md-4">
                      <card type="blog" plain class="fix-padding">
                        <div class="card-image">
                          <a href="https://www.youtube.com/watch?v=7AhWjqr-h7Y&t=5s" target="_blank" rel="noopener noreferrer">
                            <img class="img img-raised rounded" src="img/chad/snak-chad-ashe.jpg"
                            />
                          </a>
                        </div>
                        <div class="card-body">
                          <h6 class="category">
                            <br>
                            <a href="https://www.youtube.com/watch?v=7AhWjqr-h7Y&t=5s" target="_blank" rel="noopener noreferrer">
                              <b> {{ $t('clickView') }}</b>
                            </a>
                          </h6>
                          <h5 class="card-title">
                            <a href="https://www.youtube.com/watch?v=7AhWjqr-h7Y&t=5s"target="_blank" rel="noopener noreferrer">
                              Spliff N/A Kiss
                            </a>
                          </h5>
                        </div>
                      </card>
                    </div>
                    <div class="col-md-4">
                      <card type="blog" plain class="fix-padding">
                        <div class="card-image">
                          <a href="https://www.youtube.com/watch?v=8pPHF2O4pKI" target="_blank" rel="noopener noreferrer">
                            <img class="img img-raised rounded"
                                 src="img/chad/WAHALA-CHAD-ASHE.jpg"
                            />
                          </a>
                        </div>
                        <div class="card-body">
                          <h6 class="category">
                            <br>
                            <a href="https://www.youtube.com/watch?v=8pPHF2O4pKI" target="_blank" rel="noopener noreferrer">
                              <b> {{ $t('clickView') }}</b>
                            </a>
                          </h6>
                          <h5 class="card-title">
                            <a href="https://www.youtube.com/watch?v=8pPHF2O4pKI" target="_blank" rel="noopener noreferrer">
                              Wahala
                            </a>
                          </h5>
                        </div>
                      </card>
                    </div>
                    <div class="col-md-4">
                      <card type="blog" plain class="fix-padding">
                        <div class="card-image">
                          <a href="https://www.youtube.com/watch?v=Gbyoyqhxi60" target="_blank" rel="noopener noreferrer">
                            <img class="img img-raised rounded" src="img/chad/colorado-chad-ashe.jpg"
                                 />
                          </a>
                        </div>
                        <div class="card-body">
                          <h6 class="category">
                            <br>
                            <a href="https://www.youtube.com/watch?v=Gbyoyqhxi60" target="_blank" rel="noopener noreferrer">
                              <b> {{ $t('clickView') }}</b>
                            </a>
                          </h6>
                          <h5 class="card-title">
                            <a href="https://www.youtube.com/watch?v=Gbyoyqhxi60" target="_blank" rel="noopener noreferrer">
                              Colorado
                            </a>
                          </h5>
                        </div>
                      </card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="interviews" class="section section-image" style="background-image: url('img/chad/edits-18.jpg')">
          <div class="blogs-1" id="blogs-1">
            <div class="container">
              <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                  <h2 class="title">{{ $t('interviews') }}</h2>
                  <br />
                  <card type="blog" plain>
                    <div class="row" slot="image">
                      <div class="col-md-5">
                        <img class="img"
                             src="img/chad/the-hustle-logo-chad-ashe.png"
                             style="display: block;
                                    margin-left: auto;
                                    margin-right: auto;
                                    width: 100%;"/>
                      </div>
                      <div class="col-md-7">
                        <h3 class="card-title" >
                          <a href="https://youtu.be/fmkdHDxNPk4" style="color: white" target="_blank" rel="noopener noreferrer">
                            The Hustle podcast
                          </a>
                        </h3>
                        <p class="card-description" style="color: white">
                          {{ $t('hustleDescription') }}
                          <br>
                          <a href="https://youtu.be/fmkdHDxNPk4" class="text-danger" target="_blank" rel="noopener noreferrer">
                            <b> {{ $t('viewNow') }} </b>
                          </a>
                        </p>
                        <p class="author" style="color: white">
                          {{ $t('interviewWith') }}
                          <a href="https://instagram.com/the.hustlepodcast?utm_medium=copy_link" target="_blank" rel="noopener noreferrer">
                            <b style="color: white"> Steven, Tek Luciano, Talia</b>
                          </a>
                          <br>Nov 17, 2021
                        </p>
                      </div>
                    </div>
                  </card>
                  <div class="separator-line"></div>
                  <card type="blog" plain>
                    <div class="row swapcolumns">
                      <div class="col-md-7" style="color: white">
                        <h3 class="card-title">
                          <a href="https://www.youtube.com/watch?v=CuZ4xZV3alM" style="color: white" target="_blank" rel="noopener noreferrer">
                            Le Warmup Fm
                          </a>
                        </h3>
                        <p class="card-description" style="color: white">
                          {{ $t('warmUpDescription') }}
                          <br>
                          <a href="https://www.youtube.com/watch?v=CuZ4xZV3alM" class="text-danger" target="_blank" rel="noopener noreferrer">
                            <b> {{ $t('viewNow') }}</b>
                          </a>
                        </p>
                        <p class="author" style="color: white">
                          {{ $t('interviewWith') }}
                          <a href="https://instagram.com/lewarmupfm?utm_medium=copy_link" target="_blank" rel="noopener noreferrer">
                            <b style="color: white">Anthony Dagger & Freddy Loyd</b>
                          </a>
                          <br>Dec 24, 2021
                        </p>

                      </div>
                      <div class="col-md-5">
                        <div class="card-image">
                          <img class="img"
                               src="img/chad/LOGO+WARMUP-small.png"/>
                        </div>
                      </div>
                    </div>
                  </card>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        <div id="music" class="features-6" data-background-color="black">-->
<!--          <div class="container">-->
<!--            <div class="row">-->
<!--              <div class="col-md-8 ml-auto mr-auto text-center">-->
<!--                <h2 class="title">Stream now on the following platforms</h2>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row">-->
<!--              <div class="col-md-4">-->
<!--                <div class="info info-horizontal">-->
<!--                  <div class="description text-center">-->
<!--                    <h5 class="info-title">Apple Music</h5>-->
<!--                    <span class="iconify" data-icon="cib:apple-music" data-width="100" data-height="100"></span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="info info-horizontal">-->
<!--                  <div class="description text-center">-->
<!--                    <h4 class="info-title">Spotify</h4>-->
<!--                    <span class="iconify" data-icon="akar-icons:spotify-fill" data-width="100" data-height="100"></span>                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-md-4">-->
<!--                <div class="phone-container ">-->
<!--                  <img class="" v-lazy="'img/chad/edits-14.jpg'" />-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-md-4">-->
<!--                <div class="info info-horizontal">-->
<!--                  <div class="description text-center">-->
<!--                    <h5 class="info-title">Deezer</h5>-->
<!--                    <span class="iconify" data-icon="fa-brands:deezer" data-width="100" data-height="100"></span>                  </div>-->
<!--                </div>-->
<!--                <div class="info info-horizontal">-->
<!--                  <div class="description text-center">-->
<!--                    <h4 class="info-title">Youtube</h4>-->
<!--                    <span class="iconify" data-icon="akar-icons:youtube-fill" data-width="100" data-height="100"></span>                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div id="music" class="features-7 section-image" data-background-color="gray">
            <div class="col-md-8 mr-auto ml-auto text-center">
              <h2 class="title">{{ $t('streamTitle') }}</h2>
  <!--            <h4 class="description">This is the paragraph where you can write more details about your product. Keep you user engaged by providing meaningful information.</h4>-->
            </div>
            <div class="container-fluid">
              <div class="row">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="info info-horizontal">
                          <div class="description text-center">
                            <a href="https://music.apple.com/ca/artist/chad-ashe/id1517895366" target="_blank" rel="noopener noreferrer">
                              <h5 class="info-title">Apple Music</h5>
                              <span class="iconify" data-icon="cib:apple-music" data-width="100" data-height="100"></span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="info info-horizontal">
                          <div class="description text-center">
                            <a href="https://open.spotify.com/artist/1fJ07tUQeIPiDoh45GShMY" target="_blank" rel="noopener noreferrer">
                              <h4 class="info-title">Spotify</h4>
                              <span class="iconify" data-icon="akar-icons:spotify-fill" data-width="100" data-height="100"></span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="info info-horizontal">
                          <div class="description text-center">
                            <a href="https://music.amazon.ca/artists/B003Y67GXG/chad-ashe?marketplaceId=A2EUQ1WTGCTBG2&musicTerritory=CA&ref=dm_sh_YNE0U3EYLGHAwNSNZIurdbuES" target="_blank" rel="noopener noreferrer">
                              <h5 class="info-title">Amazon Music</h5>
                              <span class="iconify" data-icon="ion:logo-amazon" data-width="100" data-height="100"></span>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="info info-horizontal">
                          <div class="description text-center">
                            <a href="https://soundcloud.com/houseofashes51450" target="_blank" rel="noopener noreferrer">
                              <h4 class="info-title">Soundcloud</h4>
                              <span class="iconify" data-icon="fa-brands:soundcloud" data-width="100" data-height="100"></span>
                            </a>
                          </div>
                        </div>
                    </div>
                    </div>
                  </div>
<!--                <div class="col-md-6">-->
<!--                  <div class="image-container">-->
<!--                    <img v-lazy="'img/chad/edits-14.jpg'" alt="chad-ashe-press-photo">-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        <div id="contact" class="section section-basic-components" style="padding:0px;" data-background-color="gray">
            <div class="container">
              <div class="row">
                <div class="col-lg-5 col-md-7 ml-auto mr-auto" style="color:black; ">
                  <h2 class="title" style="padding-top: 0px;">{{ $t('contact') }}</h2>
                  <h5 class="description"style="color:black">
                    {{ $t('contactDescription') }}
                    <br/>
                    <br/>
                    <b>{{ $t('contactSignature') }}</b>
                    <br/>
                    <br/>
                        <a href="https://www.facebook.com/chadashewashere" target="_blank" style="padding:10px 10px 10px 0px;">
                          <span class="iconify" data-icon="akar-icons:facebook-fill" data-width="50" data-height="50"></span>
                        </a>
                        <a href="https://www.instagram.com/chad_ashe_was_here/" target="_blank" style="padding:10px;">
                          <span class="iconify" data-icon="akar-icons:instagram-fill" data-width="50" data-height="50"></span>
                        </a>
                        <a href="mailto:chad.ashe@gmail.com" target="_blank" style="padding:10px;">
                          <span class="iconify" data-icon="ant-design:google-plus-circle-filled" data-width="50" data-height="50"></span>
                        </a>
                  </h5>
                </div>
                <div class="col-lg-6 col-md-12">
                  <div class="image-container hide-text">
                    <img class="components-macbook" src="img/chad/edits-5.jpg" alt="ipad_img">
  <!--                  <img class="chad-responsive-img-1" src="img/chad/snak-chad-ashe.jpg" alt="table">-->
  <!--                  <img class="chad-responsive-img-2" src="img/chad/WAHALA-CHAD-ASHE.jpg" alt="share button">-->
  <!--                  <img class="chad-responsive-img-3" src="img/chad/edits-58.jpg" alt="coloured card with button">-->
  <!--                  <img class="chad-responsive-img-4" src="img/chad/edits-16.jpg" alt="coloured card">-->
  <!--                  <img class="chad-responsive-img-5" src="img/chad/edits-10.jpg" alt="social row">-->
  <!--                  <img class="chad-responsive-img-6" src="img/chad/edits-29.jpg"-->
  <!--                       alt="linked in button">-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        <footer class="footer footer-white">
          <div class="container">
            <a class="footer-brand" href="/">
              <div style="height: 30px; width: 30px; margin: auto;">
                <img src="img/chad/chad-ashe-logo.png" alt="chad ashe logo">
              </div>
              Chad Ashe
            </a>
            <ul class="pull-center">
              <li>
                <router-link :to="{ path: `/about` }" class="nav-link">
                  {{ $t('about') }}
                </router-link>
              </li>
              <li>
                <a href="#videos" class="nav-link">
                  {{ $t('videos') }}
                </a>
              </li>
              <li>
                <a href="#interviews" class="nav-link">
                  {{ $t('interviews') }}
                </a>
              </li>
              <li>
                <a href="#music" class="nav-link">
                  {{ $t('music') }}
                </a>
              </li>
              <li>
                <a href="#photos" class="nav-link">
                  {{ $t('photos') }}
                </a>
              </li>
              <li>
                <a href="#contact" class="nav-link">
                  {{ $t('contact') }}
                </a>
              </li>
            </ul>
            <ul class="social-buttons pull-right">
              <li>
                <a href="https://www.facebook.com/chadashewashere" target="_blank"
                   class="btn btn-icon btn-neutral btn-facebook">
                  <i class="fab fa-facebook"></i>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/chad_ashe_was_here/" target="_blank"
                   class="btn btn-icon btn-neutral btn-instagram">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="mailto:chad.ashe@gmail.com" target="_blank"
                   class="btn btn-icon btn-neutral btn-google">
                  <i class="fab fa-google-plus"></i>
                </a>
              </li>
            </ul>
          </div>
        </footer>
    </div>
</template>

<script>
  import { Card, InfoSection, FormGroupInput, Button, Alert } from '@/components';
  import { Carousel, CarouselItem, Tooltip } from 'element-ui'
  import { ValidationProvider, extend } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';

  const querystring = require("querystring");

  extend('required', {
    ...required,
    message: 'This field is required'
  });

  export default {
    name: 'home',
    bodyClass: 'presentation-page',
    components: {
      Alert,
      Card,
      InfoSection,
      [Carousel.name]: Carousel,
      [CarouselItem.name]: CarouselItem,
      [Tooltip.name]: Tooltip,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      ValidationProvider
    },
    data() {
      return {
        form: {
          fullName: '',
          email: '',
          phone: '',
          message: ''
        },
        value: '',
        sent: false,
        switches: {
          defaultOn: true,
          defaultOff: false
        },
      }
    },
    methods: {
      sendEmail(e) {
        // debugger
        console.log('Name is: ' + this.form.fullName)
        console.log('email is: ' + this.form.email)
        console.log('phone is: ' + this.form.phone)
        console.log('message is: ' + this.form.message)
        if(this.isValidForm)
        {
          e.preventDefault();
          this.$axios
              .post(
                  "https://sunkinginc.com/mail.php",
                  querystring.stringify(this.form)
              )
              .then(res => {
                this.sent = true;
              });
        }
        // debugger
        // console.log('Name is: ' + this.form.fullName)
        // console.log('email is: ' + this.form.email)
        // console.log('phone is: ' + this.form.phone)
        // console.log('message is: ' + this.form.message)
      },
      isValidEmail(email) {
        const re = /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      },
      isValidPhone(phone) {
        const re = /^$|^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        return re.test(String(phone).toLocaleLowerCase())
      },
      isValidMessage(message) {
        const re = /^(.{0,100})$/;
        return re.test(String(message).toLocaleLowerCase())
      },
      isValidForm() {
        // if(this.form.email && this.form.fullName && this.form.message && this.form.phone) {
        if(this.isValidEmail(this.form.email)
            && this.isValidMessage(this.form.message)
            && this.isValidEmail(this.form.phone)
            && this.form.fullName != ''
            && this.form.email    != ''
            && this.form.message  != '' ) {
          return true
        }
        else {
          return false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
    .github-buttons {
        display: flex;
        align-content: center;
    }
    .controversy-link{
      cursor: pointer;
      text-decoration: underline;
      text-decoration-color: #434343;
    }
    .controversy-link:hover{
      cursor: pointer;
      text-decoration: underline;
      color: #18ce0f;
    }
</style>
